import { useTranslation } from 'react-i18next';

import useAiChatToolLabel from '../../hooks/useAiChatToolLabel';
import useAiChatToolStatus from '../../hooks/useAiChatToolStatus';
import AiChatToolCard from '../AiChatToolCard';

import type { ReactElement } from 'react';
import type { IAiChatToolCallOf } from '../../interfaces/IAiChatToolCall';

/** The `lookupDossierPublicFacts` tool call: public facts for one dossier tab. */
function LookupDossierPublicFactsToolCall({
  part,
}: IAiChatToolCallOf<'lookupDossierPublicFacts'>): ReactElement {
  const { t } = useTranslation();
  const label = useAiChatToolLabel('lookupDossierPublicFacts');
  const status = useAiChatToolStatus(part.state);

  const factsName = part.state === 'output-available' ? part.output.facts?.name : undefined;
  const lookupError = part.state === 'output-available' ? part.output.error : undefined;
  const summary = part.state === 'output-available' ? part.output.summary : undefined;

  let statusText = status;
  if (part.state === 'output-available') {
    statusText = t(factsName
      ? 'aiChat.tools.publicCompanyLookedUp'
      : 'aiChat.tools.publicCompanyLookupMiss');
  }

  return (
    <AiChatToolCard
      name={label}
      status={statusText}
      errorText={part.errorText || lookupError}
      content={summary}
    >
      {part.input?.kind}
    </AiChatToolCard>
  );
}

export default LookupDossierPublicFactsToolCall;
